/* istanbul ignore file */

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import useTranslation from '../../hooks/use-translation';
import {
  trimUpperCase, trimToLimit, getStatusSince
} from '../../utils/utils';
import { getCovid19Risk } from '../../utils/network';
import HorizontalLoader from '../HorizontalLoader';

const inlineStyles = {
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  flexCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  riskTitle: {
    fontSize: '0.750em',
    fontFamily: 'jioType-Medium',
    textTransform: 'capitalize'
  },
  high: {
    color: '#EB0000'
  },
  medium: {
    color: '#F8602E'
  },
  low: {
    color: '#1F760F'
  },
  statusTitle: {
    fontSize: '0.750em',
    fontFamily: 'jioType-Medium',
    color: '#7D7D7D'
  },
  refreshStatusTitle: {
    marginTop: '0.25em',
    fontSize: '0.875em',
    fontFamily: 'jioType-Medium',
    color: '#214796',
    textTransform: 'capitalize'
  }
};

const getRiskStatusFromResponse = response => {
  const { covid_19_risk = '' } = response;
  return { ...response, risk: covid_19_risk };
};

const renderNoRiskAction = (props, surveyRisk, fetchUserRisk, t) => {
  if (surveyRisk.takeSurvey) {
    return <div />;
  }
  return (
    <div
      style={inlineStyles.refreshStatusTitle}
      onClick={e => {
        fetchUserRisk();
        e.stopPropagation();
      }}
    >
      {t('REFRESH_STATUS')}
    </div>
  );
};

const getRiskStyle = severity => ((severity && severity in inlineStyles) ? inlineStyles[severity] : {});

const UserRisk = props => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [surveyRisk, setSurveyRisk] = useState({ loaded: false });

  const textAlign = {
    textAlign: props.textAlign
  };

  const fetchUserRisk = async () => {
    setSurveyRisk(prevState => ({
      ...prevState,
      loaded: false
    }));
    const response = await getCovid19Risk(props.item.guru_user_id);
    const { apiResponseCode = 'failure', takeSurvey = false } = response;
    if (apiResponseCode === 'success') {
      setSurveyRisk(prevState => ({
        ...prevState,
        loaded: true,
        takeSurvey,
        ...getRiskStatusFromResponse(response)
      }));
    }
  };

  const riskMapping = {
    ESSENTIAL_SERVICES_RISK: t('ESSENTIAL_SERVICES_RISK'),
    ESSENTIAL_SERVICES_LOW_RISK: t('ESSENTIAL_SERVICES_LOW_RISK'),
    LOWRISK: t('LOW_RISK'),
    MEDIUMRISK: t('MEDIUM_RISK'),
    HIGHRISKV2WITHSYMPTOMS: t('HIGH_RISK_V2'),
    HIGHRISKWITHOUTSYMPTOMS: t('HIGH_RISK'),
    COVID19: t('COVID_19')
  };

  const riskStatus = trimUpperCase((surveyRisk.risk || '')).replace(/[\s()-]+/gi, '');

  useEffect(() => {
    fetchUserRisk();
  }, []);
  //console.log("surveyRisk:" + JSON.stringify(surveyRisk));
  return (
    <>
      {!surveyRisk.loaded && (
        <HorizontalLoader size="8px" color="#214796" />
      )}
      {surveyRisk.loaded && (
        <div style={(inlineStyles[props.riskLayout] || inlineStyles.flexColumn)}>
          {
            surveyRisk.created_at_ist && surveyRisk.risk ? (
              <>
                {
                  props.trim
                  && <div style={{ ...inlineStyles.riskTitle, ...getRiskStyle(surveyRisk.severity), ...textAlign }}>{trimToLimit((riskMapping[riskStatus] || ''), 25)}</div>
                }
                {
                  !props.trim
                  && <div style={{ ...inlineStyles.riskTitle, ...getRiskStyle(surveyRisk.severity), ...textAlign }}>{(riskMapping[riskStatus] || '')}</div>
                }
                {/* <div style={inlineStyles.statusTitle}>{`${t('STATUS_AS_ON')} ${surveyRisk.lastUpdate} `}</div> */}
                <div style={{ ...inlineStyles.statusTitle, ...textAlign }}>{getStatusSince(surveyRisk.created_at_ist, t)}</div>
              </>
            ) : renderNoRiskAction(props, surveyRisk, fetchUserRisk, t)
          }
        </div>
      )}
    </>
  );
};

export default UserRisk;
